/* file: brand/1111.js -> assets/ef-1111.js
 * EcoFlow 11.11 (5-12 Nov 2026): every moving part of the campaign.
 *   - countdowns: [data-e11-end] (epoch seconds) with [data-e11-d|h|m|s] or a
 *     single [data-e11-left] line; first paint is Liquid's, this only ticks.
 *     At zero the page reloads, so the server's gate decides what is left.
 *   - the hero's 11:11 rolls up from 00:00 like a clock, once;
 *   - .e11-r blocks rise into place once, on view;
 *   - films get their source only near the screen and play only on it;
 *   - [data-e11-copy] copies the code and says so.
 * Reduced motion: nothing rolls, rises or plays; the clock still counts.
 * Words come from window.efCampaign.t (the header prints them per locale).
 */
(function () {
  "use strict";
  var doc = document;
  var C = window.efCampaign || { t: {} };
  var T = C.t || {};
  var calm = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var each = function (sel, fn) { Array.prototype.forEach.call(doc.querySelectorAll(sel), fn); };
  var p2 = function (n) { return n < 10 ? "0" + n : "" + n; };

  /* ---- countdowns -------------------------------------------------------- */
  var clocks = [];
  each("[data-e11-end]", function (el) { clocks.push(el); });
  function tick() {
    var now = Date.now();
    clocks.forEach(function (el) {
      var left = Math.max(0, Math.floor(+el.getAttribute("data-e11-end") - now / 1000));
      if (left <= 0 && !el._done) { el._done = true; setTimeout(function () { location.reload(); }, 1500); }
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600),
          m = Math.floor(left % 3600 / 60), s = left % 60;
      var set = function (k, v) { var x = el.querySelector("[data-e11-" + k + "]"); if (x) x.textContent = v; };
      set("d", p2(d)); set("h", p2(h)); set("m", p2(m)); set("s", p2(s));
      var line = el.querySelector("[data-e11-left]");
      if (line) line.textContent = (d ? d + (T.d || "d") + " " : "") + p2(h) + ":" + p2(m) + ":" + p2(s);
    });
  }
  if (clocks.length) { tick(); setInterval(tick, 1000); }

  /* ---- copy the code ------------------------------------------------------ */
  each("[data-e11-copy]", function (b) {
    b.addEventListener("click", function () {
      var code = b.getAttribute("data-e11-copy"), lbl = b.querySelector(".e11-copy__btn") || b;
      var was = lbl.textContent;
      var ok = function () { lbl.textContent = T.copied || "Copied"; setTimeout(function () { lbl.textContent = was; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok);
      else { var i = doc.createElement("input"); i.value = code; doc.body.appendChild(i); i.select();
             try { doc.execCommand("copy"); } catch (e) {} i.remove(); ok(); }
    });
  });

  /* ---- spin opener without a wheel --------------------------------------- */
  /* ef-spin.js opens the draw for [data-ef-spin-open]. If the visitor has
     already claimed, or the wheel is not on the page, send them to the deals. */
  each("[data-ef-spin-open]", function (b) {
    b.addEventListener("click", function () {
      setTimeout(function () {
        var dlg = doc.querySelector("[data-ef-spinmodal]");
        if (!dlg || !dlg.open) { var t = doc.getElementById("e11-deals"); if (t) t.scrollIntoView({ behavior: calm ? "auto" : "smooth" }); }
      }, 60);
    });
  });

  /* ---- product pages: the slash deal on the price itself -------------------- */
  /* Owner, 02NOV2026: the strikethrough without any compare-at price in
     Shopify. The theme keeps writing its own price (it re-writes it on every
     variant change), so that element stays, hidden, and is READ: the deal line
     beside it is the code price, the price the cart charges struck through, and
     the code named. Main price, sticky bar, mobile sheet and the Care+ add-on. */
  var CC = window.efCampaign;
  var onSale = CC && CC.start && Date.now() >= CC.start && Date.now() <= CC.end;
  var ph = /\/products\/([^\/?#]+)/.exec(location.pathname);
  if (onSale && ph && CC.exclude.indexOf(decodeURIComponent(ph[1])) < 0) {
    var RM = function (c) {
      var n = c / 100;
      return "RM " + n.toLocaleString("en-MY", n % 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : { maximumFractionDigits: 0 });
    };
    var paintPrice = function (el) {
      var x = /RM\s?([\d,]+(?:\.\d+)?)/.exec(el.textContent || "");
      if (!x) return;
      var cents = Math.round(parseFloat(x[1].replace(/,/g, "")) * 100);
      if (!cents) return;
      var cut = Math.round(cents * CC.pct / 100), deal = cents - cut;
      var d = el._e11;
      if (!d) {
        d = doc.createElement("span"); d.className = "e11-pdp";
        if (el.getAttribute("style")) d.setAttribute("style", el.getAttribute("style"));
        el.parentNode.insertBefore(d, el.nextSibling);
        el._e11 = d; el.classList.add("e11-pdp__orig");
      }
      d.textContent = "";
      var add = function (cls, t, tag) { var e = doc.createElement(tag || "span"); e.className = cls; e.textContent = t; d.appendChild(e); };
      add("e11-pdp__deal", RM(deal));
      add("e11-pdp__was", RM(cents), "s");
      add("e11-pdp__save", CC.t.save + " " + RM(cut) + " " + CC.t.with + " " + CC.code);
    };
    each("[data-ef-price], [data-ef-pbar-price], .eft-sheet__current-price, .eft-care-addon .eft-price", function (el) {
      paintPrice(el);
      new MutationObserver(function () { paintPrice(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  var root = doc.querySelector(".e11");
  if (!root) return;

  /* ---- the sale page's tab bar ----------------------------------------- */
  /* It sticks under the site header when the header itself sticks, and the
     tab for the section on screen is marked. */
  var tabs = root.querySelector(".e11p-tabs");
  if (tabs) {
    var hdr = doc.querySelector(".ef-header, header");
    /* The site header slides away on the way down and back on the way up, so
       the bar follows the header's visible bottom edge, not its height. */
    var last = -1, busy = false;
    var setTop = function () {
      busy = false;
      var top = 0;
      if (hdr) {
        var ps = getComputedStyle(hdr).position;
        if (ps === "sticky" || ps === "fixed") top = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
      }
      if (top !== last) { last = top; root.style.setProperty("--e11-top", top + "px"); }
    };
    var later = function () { if (!busy) { busy = true; requestAnimationFrame(setTop); } };
    setTop();
    window.addEventListener("scroll", later, { passive: true });
    window.addEventListener("resize", later);
    if (!calm) tabs.style.transition = "top .25s cubic-bezier(.22,1,.36,1)";
    var links = Array.prototype.slice.call(tabs.querySelectorAll("a[href^='#']"));
    if ("IntersectionObserver" in window) {
      var spy = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.setAttribute("aria-current", a.getAttribute("href") === "#" + e.target.id ? "true" : "false"); });
        });
      }, { rootMargin: "-40% 0px -55% 0px" });
      links.forEach(function (a) { var t = doc.getElementById(a.getAttribute("href").slice(1)); if (t) spy.observe(t); });
    }
  }

  /* ---- the 11:11 roll ------------------------------------------------------ */
  /* A clock running from 00:00 to 11:11 in about a second and a half, easing
     into the last minutes -- every frame is a real time, never random digits. */
  var big = root.querySelector("[data-e11-roll]");
  if (big && !calm && window.requestAnimationFrame) {
    var dg = big.querySelectorAll("[data-e11-digit]"), t0 = null, DUR = 1500, TO = 11 * 60 + 11;
    var show = function (mins) {
      var s = p2(Math.floor(mins / 60)) + p2(mins % 60);
      for (var i = 0; i < dg.length; i++) dg[i].textContent = s.charAt(i);
    };
    show(0);
    var step = function (ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / DUR), e = 1 - Math.pow(1 - k, 3);
      show(Math.round(TO * e));
      if (k < 1) requestAnimationFrame(step);
    };
    setTimeout(function () { requestAnimationFrame(step); }, 250);
  }

  /* ---- rise on view ---------------------------------------------------------- */
  if (!calm && "IntersectionObserver" in window) {
    root.classList.add("is-armed");
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    each(".e11 .e11-r", function (el) { io.observe(el); });
  }

  /* ---- films ------------------------------------------------------------------ */
  /* One watcher: the source goes on the first time a film nears the screen,
     and it plays only while it is on it. (Two watchers raced: the "on screen"
     one fired before there was a source to play, and never fired again.) */
  if (!calm && "IntersectionObserver" in window) {
    var watch = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          /* a phone gets the lighter cut when the page offers one */
          if (!v.src) { v.src = (window.innerWidth <= 760 && v.getAttribute("data-src-sm")) || v.getAttribute("data-src"); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (v.src) v.pause();
      });
    }, { rootMargin: "200px 0px", threshold: 0.01 });
    /* every 11.11 block on the page, not only the first (the landing now opens
       with the promo hero, ahead of the 11.11 section and its spotlight film) */
    each(".e11 video[data-src]", function (v) { watch.observe(v); });
  }
})();
